<template>
  <v-container>
    <div class="d-flex justify-end mt-6 mb-4">
      <avs-createButton
        small
        @click.stop="addInspection()"
        :spantext="$t('actions.add', { entity: $tc('commons.inspection', 1).toLowerCase() })"
        :name="$t('actions.new_female', { entity: $tc('commons.inspection', 1).toLowerCase() })"
      >
      </avs-createButton>
    </div>
    <div class="d-flex row--dense">
      <v-list class="ml-2">
        <v-list-item
          v-for="(inspection, inspectionIndex) in step.inspections.filter(s => !s.deleted)"
          :key="inspectionIndex"
        >
          <v-list-item-content>
            <div class="d-flex flex-wrap row--dense">
              <div class="col-6 col-lg-3">
                <v-text-field
                  v-model="inspection.name"
                  :rules="rules.inspection.name"
                  counter="255"
                  maxlength="255"
                  clearable
                  dense
                  outlined
                  :label="$t('commons.inspection')"
                />
              </div>
              <div class="col-6 col-lg-2">
                <v-select
                  v-model="inspection.status"
                  :rules="rules.inspection.status"
                  :items="STATUS_ITEMS"
                  dense
                  outlined
                  :label="$t('commons.status.name')"
                ></v-select>
              </div>
              <div class="col-6 col-lg-3">
                <DatetimePicker
                  v-model="inspection.start_date"
                  :disabled="!step.start_date || !step.deadline"
                  :max="getMinDatetime(step.deadline, inspection.deadline)"
                  :min="step.start_date"
                  :textFieldProps="{
                    dense: true,
                    label: $t('commons.date.start_date'),
                    rules: rules.inspection.start_date
                  }"
                />
              </div>
              <div class="col-6 col-lg-3">
                <DatetimePicker
                  v-model="inspection.end_date"
                  :disabled="!inspection.start_date"
                  :max="step.deadline"
                  :min="inspection.start_date"
                  :textFieldProps="{
                    dense: true,
                    label: $t('commons.date.end_date'),
                    rules: rules.inspection.end_date
                  }"
                />
              </div>
              <div class="col-1 col-lg-1">
                <avs-deleteButton
                  @click="openDeleteDialog(inspectionIndex)"
                  :spantext="
                    $t('actions.delete', {
                      entity: $tc('commons.inspection', 1).toLowerCase()
                    })
                  "
                />
              </div>
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
    <avs-deleteDialog
      v-model="deleteDialogIsOpen"
      @cancel="closeDeleteDialog"
      @delete="deleteInspection"
      resource="inspection"
    />
  </v-container>
</template>

<script>
import { STATUS_ITEMS } from "@/utils/consts"
import { mkProjectStepInspection } from "@/utils/datamodels"
import { getMinDatetime } from "@/utils/datetime"
import { required } from "@/utils/validator"
import { InspectionService } from "@/services"

export default {
  name: "ProjectActivityInspection",
  components: {
    DatetimePicker: () => import("@/components/inputs/DatetimePicker.vue")
  },
  props: {
    maxDatetime: {
      type: Object,
      required: true
    },
    minDatetime: {
      type: Object,
      required: true
    },
    step: {
      type: Object,
      required: true
    },
    rulesUpdate: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    rules() {
      return {
        name: [required],
        start_date: [required],
        deadline: [required],
        inspection: {
          name: [required],
          status: [required],
          start_date: [required],
          end_date: [required]
        },
        ...this.rulesUpdate
      }
    }
  },
  data() {
    return {
      deleteDialogIsOpen: false,
      STATUS_ITEMS,
      inspectionIndex: null
    }
  },
  methods: {
    getMinDatetime,
    hasBeenUpdated() {
      this.$emit("updated")
    },
    addInspection() {
      let order = this.step.inspections.length + 1
      this.step.inspections.push(
        mkProjectStepInspection(this.step.start_date, this.step.deadline, order)
      )
    },
    deleteInspection() {
      let inspection = this.step.inspections[this.inspectionIndex]
      if (inspection.id) {
        InspectionService.remove(this, inspection.id).then(response => {
          this.send(
            this.$t("messages.success.deleted", { entity: this.$tc("commons.inspection", 1) }),
            "success"
          )
        })
        this.hasBeenUpdated()
      } else {
        this.step.inspections.splice(this.inspectionIndex, 1)
        this.send(
          this.$t("messages.success.deleted", { entity: this.$tc("commons.inspection", 1) }),
          "success"
        )
      }
      this.closeDeleteDialog()
    },
    closeDeleteDialog() {
      this.deleteDialogIsOpen = false
    },
    openDeleteDialog(inspectionIndex) {
      this.deleteDialogIsOpen = true
      this.inspectionIndex = inspectionIndex
    },
    send(msg, color) {
      this.$store.commit("app/message", { msg, color })
    }
  }
}
</script>
